import { useState } from 'react';
import { Box, Heading, Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { createSeller } from '@/lib/api';
import { toaster } from '@/components/ui/toaster';
import { EMPTY_SELLER_FORM, SellerForm, type SellerFormValues } from './SellerForm';

export function SellerNew() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(values: SellerFormValues) {
    setError(null);
    setSubmitting(true);
    try {
      const result = await createSeller({
        fullName: values.fullName.trim(),
        email: values.email.trim() || null,
        phone: values.phone.trim() || null,
        notes: values.notes.trim() || null,
      });
      if ('conflict' in result) {
        setError('Ya existe un vendedor con este correo.');
        return;
      }
      toaster.create({ title: 'Vendedor creado', description: values.fullName, type: 'success' });
      navigate('/vendedores');
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'No se pudo crear';
      setError(msg);
      toaster.create({ title: 'No se pudo crear el vendedor', description: msg, type: 'error' });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Box px={{ base: '4', md: '8' }} py={{ base: '6', md: '8' }}>
      <Stack gap="6" maxW="3xl">
        <Stack gap="1">
          <Text fontSize="xs" color="fg.muted" textTransform="uppercase" letterSpacing="0.06em" fontWeight="700">
            Vendedores
          </Text>
          <Heading size={{ base: 'xl', md: '2xl' }} letterSpacing="-0.02em">
            Nuevo vendedor
          </Heading>
        </Stack>
        <SellerForm
          initial={EMPTY_SELLER_FORM}
          submitLabel="Crear vendedor"
          submitting={submitting}
          error={error}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/vendedores')}
        />
      </Stack>
    </Box>
  );
}
